export default __webpack_public_path__ + "static/media/i3.badcb8cf.png";